import { combineReducers } from '@reduxjs/toolkit';
import data from './dataSlice';
import state from './stateSlice';

const menuListReducer = combineReducers({ state, data });
export default menuListReducer;
